
export function ErrorPage() {
    return (
        <div
            style={{
                textAlign: "center",
                marginTop: "10%",
                fontSize: "25px",
                color: "red",
            }}
        >
            <h1>500</h1>
            <span> Đã có lỗi xảy ra vui lòng thử lại sau hoặc quay về{" "}
                <a href="/" style={{ color: "blue" }}>trang chủ</a>
            </span>
        </div>
    );
}


